"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PiggyBankIcon = require("./PiggyBankIcon");

var _PiggyBankIcon2 = _interopRequireDefault(_PiggyBankIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PiggyBankIcon2.default;